(() => {
  const productPath = '/products/volumizing-shampoo-for-fine-flat-thinning-hair-10-fl-oz';
  function showBadges() {
    const template = document.querySelector('template[data-vassia-review-template]');
    const article = document.querySelector('.article-template__content');
    if (!template || !article || !template.content.firstElementChild) return;
    let inserted = 0;
    for (const callout of article.querySelectorAll('.vassia-reader__cta')) {
      const productLink = Array.from(callout.querySelectorAll('a[href]')).find(link => link.getAttribute('href')?.includes(productPath));
      if (!productLink || callout.querySelector('.vassia-review-badge')) continue;
      const badge = template.content.firstElementChild.cloneNode(true);
      const textLink = productLink.closest('p');
      if (textLink) textLink.before(badge);
      else productLink.before(badge);
      inserted++;
    }
    if (inserted || article.querySelector('.vassia-review-badge')) return;
    const link = Array.from(article.querySelectorAll('a[href]')).find(a => a.getAttribute('href')?.includes(productPath));
    if (!link) return;
    const badge = template.content.firstElementChild.cloneNode(true);
    const paragraph = link.closest('p');
    if (paragraph) paragraph.after(badge);
    else link.after(badge);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', showBadges, { once: true });
  else showBadges();
  document.addEventListener('shopify:section:load', showBadges);
})();
